import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { FtpService } from 'src/app/shared/services/ftp/ftp.service';
import { AlertService } from 'src/app/shared';

@Component({
  selector: 'app-ftp-details',
  templateUrl: './ftp-details.component.html',
  styleUrls: ['./ftp-details.component.scss']
})
export class FtpDetailsComponent implements OnInit {

  ftpdetails: any = {
    servername: '',
    username: '',
    port: '',
    password: '',
    folder: '/',
  }
  sender = "ftp-details";

  error: any;



  constructor(
    private FtpDetailsApi: FtpService,
    private alertService: AlertService,
  ) { }

  ngOnInit() {
    this.getFtpById();
  }


  onSave() {
    this.error = " ";
    if (!this.ftpdetails.servername) {
      this.error = "please enter server name";
      this.alertService.err(this.sender, this.error)
      return false;
    }
    if (!this.ftpdetails.username) {
      this.error = "please enter username name";
      this.alertService.err(this.sender, this.error)
      return false;
    }
    if (!this.ftpdetails._id && !this.ftpdetails.password) {
      this.error = "please enter password ";
      this.alertService.err(this.sender, this.error)
      return false;
    }
    if (!this.ftpdetails.folder) {
      this.error = "please enter folder";
      this.alertService.err(this.sender, this.error)
      return false;
    }

    var data = Object.assign({}, this.ftpdetails);
    this.FtpDetailsApi.saveFtpDetails(data)
      .pipe(first())
      .subscribe(res => {
        if (res["status"] == "error") {
          this.alertService.err(this.sender, res["message"]);
          return;
        }
        this.alertService.show(this.sender, "FTP updated successfully..");
        this.getFtpById();
      });
  }

  getFtpById() {
    this.FtpDetailsApi.getFtpById()
      .pipe(first())
      .subscribe(res => {
        if (res  ) {
          this.ftpdetails = res;
        }
      });

  }
}
